import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  DialogContentText,
  TextField,
  Grid,
} from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import { Controller, useForm } from 'react-hook-form';
import { z } from 'zod';

export const teamSchema = z.object({
  name: z.string().min(1, 'Team Name is required'),
});

const AddTeamDialog = ({ isOpen, onClose, onSubmit, team, isViewOnly = false, }) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: zodResolver(teamSchema),
    values: {
      name: team?.name || '',
    },
    disabled: isViewOnly,
  });

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{team ? 'Edit Team' : 'Add New Team'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please fill in the following fields to add a new team.
        </DialogContentText>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Team Name"
                    variant="outlined"
                    fullWidth
                    error={!!errors.name}
                    helperText={errors.name ? errors.name.message : ''}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '8px',
                }}>
                <Button onClick={onClose} color="secondary" variant="outlined">
                  Cancel
                </Button>
                <Button type="submit" color="primary" variant="contained">
                  {team ? 'Save' : 'Add Team'}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddTeamDialog;
